import Expandable from './expandable';

document.addEventListener( 'DOMContentLoaded', function() {
	const acordeonContainer = document.querySelector( '.c-acordeon' );
	if ( ! acordeonContainer ) {
		return;
	}

	Expandable( acordeonContainer );
} );
